module.exports = __webpack_public_path__ + "img/blue-menu.a46df624.png";